var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapview",attrs:{"id":"mapview"}},[(_vm.mapviewState.mode = '2d')?_c('view2d'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }